
import { defineComponent, onMounted, ref} from 'vue';
import Button from "@/components/common/buttons/Button.vue";
import iosShareIcon from '@/content/assets/img/webapp-share.svg';
import closeIcon from '@/content/assets/img/close.svg';

let deferredPrompt:any;

// Detects if device is on iOS
function isIOS() {
    return /iPhone|iPad|iPod/.test(navigator.userAgent);
}

// Detects if device is in standalone mode
function isInStandaloneMode() {
    return ('standalone' in window.navigator) && ((window.navigator as any).standalone);
}

//  Beforeinstallprompt handler is only relevant for non iOS devices.
if(!isIOS()){
  window.addEventListener('beforeinstallprompt', function(event:any) {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  event.preventDefault();
  // Stash the event so it can be triggered later.
  deferredPrompt = event;  
  });
} 

export default defineComponent({
  name: 'AddToHomeScreen',
  setup(props, context) {
    const isWaitingForEvent = ref(true)
    const addToHomePrompted = ref(localStorage.getItem("AddToHomePrompted") === "true")
    const isPwa = window.matchMedia('(display-mode: standalone)').matches;
    onMounted(() => {
      setTimeout(()=>{
        isWaitingForEvent.value = false
      }, 3000)
    });    

    // Set boolean state for AddToHomePrompted into localstorage
    const addToHome = () => {
      localStorage.setItem("AddToHomePrompted", "true");
      addToHomePrompted.value = true;
    };
    
    const showIosModal = isIOS() && !isInStandaloneMode()
    return () => {
      if(showIosModal && !addToHomePrompted.value) {
        return (
          <div class="add-to-home-modal--ios">
            <div class="popup-text">
              <span>Add the Siemens.FM Web-App to your device: Tap</span>
              &nbsp;&nbsp;
              <img  class="share-icon" src={iosShareIcon} width="24" height="24" alt="Share for iOS"/>
              &nbsp;&nbsp;
              <span>then select the option "Add to Home Screen".</span>
            </div>
            <button onClick={addToHome}>
              <img  class="close-icon" src={closeIcon} width="24" height="24" alt="Close"/>   
            </button>
          </div>
        )
      } 

      if (isWaitingForEvent.value) {
        return null
      } 
      if (isPwa || addToHomePrompted.value || !deferredPrompt) {
        return null; // Or return an empty fragment <> </>
      }

      return (<div class="add-to-home-modal" id="addToHomeModal">
        <div class="home-header">Add to home screen</div>
        <div class="button-bar">
          <Button type="Tertiary"
            onClick={addToHome}
            >
              Cancel
            </Button>
          <Button type="Primary"
            id=""
            ref="addBtn"
            class="button button--Primary"
            onClick={() => {
              deferredPrompt?.prompt()
              
              // Wait for the user to respond to the prompt
              deferredPrompt?.userChoice.then((choiceResult: any) => {
                localStorage.setItem("AddToHomePrompted", "true")
                addToHomePrompted.value = true
              })
            }}
          >
            Add
          </Button>
      </div>
      </div >)
    } 
      
  }
});
